import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-restoreleads',
  templateUrl: './restoreleads.component.html',
  styleUrls: ['./restoreleads.component.css']
})
export class RestoreleadsComponent implements OnInit {
  checkedLeads = [];
  allleads: any = [];
  ischecked: boolean = false;
  checkallbox: boolean = false;
  public dataSource = new MatTableDataSource<any>();
  public displayedColumns: any[];
  public is_betch:string='all';
  batchfile:any=[];
  dialerlist: any[]
  betchfiledata:any=[];
  cD: number = -1;
  ismltcheck:boolean=false;
  isIntermediate:boolean=false;
  rowlen:any;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogdata: any, public dialogRef: MatDialogRef<RestoreleadsComponent>) {
    this.displayedColumns = ['agents', 'filename', 'leads', 'delete_date'];
  }

  ngOnInit() {
    this.rowlen=this.dialogdata.data.length;
    if (this.dialogdata) {
      this.batchfile =this.dialogdata.batchfile;
      this.dataSource.data = this.dialogdata.data;
      for (let i = 0; i < this.dialogdata.data.length; i++) {
        this.allleads[i] = this.dialogdata.data[i].id;
      }
    }

    // @dialer mapping
    if (sessionStorage.getItem("allcampaign")) {
      this.dialerlist = JSON.parse(sessionStorage.getItem("allcampaign"))
    }
  }

  OnallCkeck(events: any) {
    console.log(this.allleads);
    console.log(events);
    this.checkedLeads = [];
    if (events.checked=='true' || events.checked==true) {
      this.ismltcheck=true;
      this.isIntermediate=false;
      this.ischecked = true;
      this.checkallbox = true;
      this.checkedLeads = this.allleads
      console.log("TRUE",this.checkedLeads);
    }
    else {
      console.log("FALSE");
      this.ischecked = false;
      this.checkallbox = false;
      this.ismltcheck=false;
      this.isIntermediate=false;
      this.checkedLeads = [];
    }
  }

  OnSingleCkeck(events: any, index: number, leadid: number) {
    this.ischecked = true;
    console.log("Check :: " + events.checked + "  INDEX:: " + index + " LEAD:: " + leadid);
    if (events.checked) {
      this.ismltcheck=false;
      this.isIntermediate=true;
      this.checkedLeads.push(leadid);
      if(this.checkedLeads.length==this.rowlen)
        this.ismltcheck=true;this.isIntermediate=false;
    }else{
      let crindex = this.allleads.findIndex(function (ele, i) {
        return ele.id === leadid;
      });
      this.checkedLeads.splice(crindex, 1);

      if(this.checkedLeads.length>0){
        this.ismltcheck=false;
        this.isIntermediate=true;
      }else{
        this.ismltcheck=false;
        this.isIntermediate=false;
        this.checkedLeads=[];
        this.ngOnInit();
      }
    }
    console.log(this.checkedLeads);
  }

  RestoreLeads() {
    console.log("CD~~",this.cD);      
      this.dialogRef.close({
        restoreType:this.is_betch,
        checkedLeads: this.checkedLeads
      });

    // if (this.cD > 0) {
    //   console.log("CD~~",this.cD);      
    //   this.dialogRef.close({
    //     checkedLeads: this.checkedLeads
    //     // id_dialer: this.cD
    //   });
    // } else {
    //   // alert("Kindly select atleast 1 dialer to restore the leads.")
    //   return false
    // }
  }

  Close() {
    this.dialogRef.close();
  }
  ChangeType(event){
    this.is_betch=event.value;
  }
  ChangeLeadList(event){
    this.checkedLeads.push(event.value.id);
    this.betchfiledata=event.value;
  console.log(event.value);
  }
}